import { defineModule } from '@portal/kernel';

/** Notification center: inbox, realtime push and e-mail (docs/design/P3_SHARED_SERVICES.md §2.1). */
export const manifest = defineModule({
  key: 'core-notification',
  version: '0.1.0',
  kind: 'core',
  coreVersion: '^0.1.0',
  name: { vi: 'Thông báo', en: 'Notifications' },
  description: {
    vi: 'Hộp thư thông báo trong Portal, đẩy tức thời và gửi email theo tuỳ chọn của từng người.',
    en: 'In-Portal inbox, realtime push and e-mail according to each user’s preferences.',
  },
  dependsOn: ['core-system', 'core-identity'],
  database: { schema: 'core_notification' },
});
